function sanitizeFilename(title: string): string {
  const sanitized = title
    .trim()
    .replace(/[<>:"/\\|?*\x00-\x1f]/g, '')
    .replace(/\s+/g, ' ')
    .slice(0, 120)

  return sanitized || 'document'
}

export function downloadMarkdownFile(title: string | undefined, markdown: string) {
  const filename = `${sanitizeFilename(title ?? '')}.md`
  const blob = new Blob([markdown], { type: 'text/markdown;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}
